import { useFormContext } from "react-hook-form";
import { FormControl, Input, InputLabel } from "@mui/material";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";

const Index = (props: any) => {
  const { register } = useFormContext();
  return (
    <FormControl fullWidth error={!daLiJePoljeValidno(props.nazivPolja)}>
      <InputLabel htmlFor={props.nazivPolja}>*Mjesto (Town)</InputLabel>
      <Input aria-describedby="mjesto" {...register(props.nazivPolja)} />
      <PorukaGreskePolja nazivPolja={props.nazivPolja} />
    </FormControl>
  );
};

export default Index;
